export default "__VITE_ASSET__9n$LkIUw__"